class ProductPrice extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.compare_price = this.querySelector(".product-price--compare");
        this.price = this.querySelector(".product-price--original");
        this.reference_unit = this.querySelector(".product-price--reference-unit");
        this.reference_value = this.querySelector(".product-price--reference-value");
        this.unit_price = this.querySelector(".product-price--unit-price");
        this.unit_price_container = this.querySelector(".product-price--unit-container");
        this.updatePriceListener();
    }

    disconnectedCallback() {
        window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
    }

    updatePriceListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`, ({ detail: { variant } }) => {
            this.updatePrices(variant);
        });
    }

    updatePrices(variant) {
        if (variant) {
            this.removeAttribute("style");

            // Update original price
            const originalPriceHTML = theme.utils.formatMoney(variant.price);
            if (this.price.innerHTML !== originalPriceHTML) {
                this.price.innerHTML = originalPriceHTML;

                // Optional: Update discount message based on the comparison price
                const compareAtPrice = variant.compare_at_price ? variant.compare_at_price : 0;
                if (compareAtPrice > variant.price) {
                    const discountPercentage = Math.round(((compareAtPrice - variant.price) / compareAtPrice) * 100);
                    this.price.innerHTML += ` (${discountPercentage}% off)`;
                    this.compare_price.style.display = "flex"; // Show comparison price
                    this.compare_price.querySelector(".comp-value-pdp").innerHTML = `Comp Value: ${theme.utils.formatMoney(compareAtPrice)}`;
                } else {
                    this.compare_price.style.display = "none"; // Hide if no comparison price
                }
            }

            // Update unit price if available
            if (variant.unit_price_measurement) {
                this.unit_price.innerHTML = theme.utils.formatMoney(variant.unit_price);
                this.reference_unit.innerHTML = variant.unit_price_measurement.reference_unit;

                if (variant.unit_price_measurement.reference_value === 1 && this.reference_value) {
                    this.reference_value.style.display = "none"; // Hide if reference value is 1
                } else if (this.reference_value) {
                    this.reference_value.innerHTML = variant.unit_price_measurement.reference_value; // Update reference value
                    this.reference_value.style.display = "block"; // Show reference value
                }

                this.unit_price_container.style.display = "flex"; // Show unit price container
            } else {
                this.unit_price_container.style.display = "none"; // Hide if no unit price
            }
        } else {
            this.style.display = "none"; // Hide if no variant
        }
    }
}

// Define the custom element if it is not already defined
const productPriceEl = customElements.get("product-price-root");
if (!productPriceEl) {
    customElements.define("product-price-root", ProductPrice);
}
